module.exports = __webpack_public_path__ + "static/media/blackhole.3245e03e.gif";